/* eslint-disable @typescript-eslint/naming-convention -- Genesys preset naming */
import type { AppConfiguration, GetCustomerQuery } from '../models';

export interface GetCustomerDataParams extends Pick<AppConfiguration, 'currentLanguage' | 'tenant'> {
  data: GetCustomerQuery | undefined;
}

export interface CustomerData {
  'context.customField1Label': string;
  'context.customField1': string;
  'context.customField2Label': string;
  'context.customField2': number | string;
  'context.customField3Label': string;
  'context.customField3': string;
  'context.customField4Label': string;
  'context.customField4': string;
  'context.customerId': string;
  'context.email': string;
  'context.firstName': string;
  'context.lastName': string;
  'context.phoneNumber': string;
  'context.source': string;
}

export const getCustomerData = ({ currentLanguage, data, tenant }: GetCustomerDataParams): CustomerData => {
  const {
    customerId: customerCustomerId,
    consultantNumber,
    customerType,
    emails,
    firstName,
    lastName,
    phones,
  } = data?.customer ?? {};

  const response = {
    'context.customField1Label': 'Customer Title',
    'context.customField1': customerType?.description ?? 'Anonymous',
    'context.customField2Label': 'Consultant Number',
    'context.customField2': consultantNumber == null ? '' : consultantNumber,
    'context.customField3Label': 'Language Code',
    'context.customField3': currentLanguage.slice(0, 2).toUpperCase(),
    'context.customField4Label': 'Market Code',
    'context.customField4': tenant.toUpperCase(),
    'context.customerId': customerCustomerId ?? '',
    'context.email': emails?.[0]?.emailAddress ?? '',
    'context.firstName': firstName ?? '',
    'context.lastName': lastName ?? '',
    'context.phoneNumber': phones?.[0]?.telephoneNumber ?? '',
    'context.source': 'web',
  };

  // eslint-disable-next-line no-console -- debug info required to investigate issues
  console.log(response);

  return response;
};
